import {
    Box,
    Button,
    CardContent,
    FormControlLabel,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { getCodUsuarioRegistrou, validateField } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class MarcaVeiculoForm extends Component {
    state = {
        isNewRecord: false,
        isView: false,
        marcaveiculo: {
            codmarcaveiculo: '',
            descmarcaveiculo: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descmarcaveiculo: {
                presence: { allowEmpty: false, message: 'Descrição da marca obrigatória' },
                length: { maximum: 64 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;

        try {
            if (!isNaN(Number(id))) {
                await this.loadMarcasVeiculo(id, location.pathname.includes('/view'));
            } else if (id === 'novo') {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    marcaveiculo: this.getMarcaVeiculoDefault()
                });
            }
        } catch (error) {
            console.error('Erro ao carregar marca de veículo:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar marca de veículo!'
            );
        }
    };

    /* Retorna a marca de veículo padrão */
    getMarcaVeiculoDefault = () => ({
        codmarcaveiculo: '',
        descmarcaveiculo: '',
        inativo: ANAO
    });

    /* Carrega as marcas de veículo */
    loadMarcasVeiculo = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/marcaveiculo/${id}`);
        const registro = response?.data?.data?.[0];

        if (!registro) {
            this.handleOpenAlert('Marca de veículo não encontrada!');

            history.push('/frotas/marcaveiculo');

            return;
        }

        this.setState({
            marcaveiculo: {
                codmarcaveiculo: registro.codmarcaveiculo || '',
                descmarcaveiculo: registro.descmarcaveiculo || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        let adjustedValue =
            type === 'checkbox' ? (checked ? ANAO : ASIM) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            marcaveiculo: {
                ...prevState.marcaveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de marca de veículo */
    getPayloadMarcaVeiculo = () => {
        const { marcaveiculo } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();
        const usuarioregistrou = sessionStorage.getItem('usuario') || sessionStorage.getItem('user');

        if (!codusuarioregistrou && !usuarioregistrou) {
            throw new Error('Usuário não encontrado!');
        }

        return {
            descmarcaveiculo: marcaveiculo.descmarcaveiculo || '',
            inativo: marcaveiculo.inativo || ANAO,
            codusuarioregistrou,
            usuarioregistrou
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { marcaveiculo, isNewRecord } = this.state;
        const { history, loadMarcasVeiculo } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadMarcaVeiculo();

            if (isNewRecord) {
                await api.post('/marcaveiculo', payload);
            } else {
                await api.put(`/marcaveiculo/${marcaveiculo.codmarcaveiculo}`, payload);
            }

            if (loadMarcasVeiculo) loadMarcasVeiculo();

            history.push('/frotas/marcaveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/marcaveiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { marcaveiculo, schema } = this.state;
        let errors = {};

        // valida os campos do schema
        const requiredFields = [
            'descmarcaveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, marcaveiculo[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    render() {
        const {
            errors,
            isView,
            marcaveiculo,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Marca de veículos {marcaveiculo.codmarcaveiculo}
                        </Typography>

                        <FormControlLabel
                            label={(marcaveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(marcaveiculo.inativo === ASIM)}
                                    name="inativo"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descmarcaveiculo"
                            value={marcaveiculo.descmarcaveiculo || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descmarcaveiculo || ''}
                            error={!!errors.descmarcaveiculo}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{ minWidth: 300 }}
                        />
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default MarcaVeiculoForm;